import { Component } from '@angular/core';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { ResponsibleGamingService } from 'src/app/services/responsible-gaming-service/responsible-gaming.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { AppstorageTsService } from 'src/app/services/appstorage/appstorage.ts.service';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss'],
})
export class DeleteAccountComponent {
  public feautureCustomerSupportURL: string;
  public isMobileApp: boolean = false;
  public loggingOut: boolean = false;

  constructor(
    private readonly responsibleGamingService: ResponsibleGamingService,
    public appLinks: AppLinksService,
    public config: ConfigService,
    private logoutService: LogoutService,
    private navigator: Navigator,
    private appStorageService: AppstorageTsService
  ) {
  }

  ngOnInit() {
    this.feautureCustomerSupportURL = this.config.getConfig().FEATURE_CUSTOMER_SUPPORT_URL;
  }

  onCloseAccount() {
    this.responsibleGamingService.callCloseAccount().subscribe((res: any) => {
      if (res.result == 1) {
        this.loggingOut = true;
        setTimeout(() => {
          this.appStorageService.clear();
          this.logoutService.callLogout();
        }, 1000);
      }
    });
  }

  protected onLogout(): any {
    return this.logoutService.onLogout();
  }

  protected goback() {
    return this.navigator.dismiss();
  }

  protected goToFeautureCustomerSupportURL(): any {
    return this.appLinks.openExternalPage(this.feautureCustomerSupportURL);
  }

}
